import React from "react";
import { Form, Input } from "antd";
import { MailOutlined } from "@ant-design/icons";

const BusinessEmail = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="email"
      label="Email"
      rules={[
        {
          required: true,
          message: "Please input email",
        },
        {
          type: "email",
          message: "Wrong email format",
        },
      ]}
    >
      <Input
        prefix={<MailOutlined className="form-item-icon" />}
        placeholder="Email"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BusinessEmail;
